import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Menu, Icon} from 'antd';
import {renderNode} from '@/library/utils/tree-utils';
import Link from '../page-link';
import './style.less';
import { L } from '../../lib/abpUtility';
const SubMenu = Menu.SubMenu;
const IconFont = Icon.createFromIconfontCN({
    scriptUrl: "//at.alicdn.com/t/c/font_3839748_s1gfcu8wrtr.js",
});
export default class HeaderMenu extends Component {
    static propTypes = {
        dataSource: PropTypes.array,    // 菜单数据
        theme: PropTypes.string,        // 主题
        selectedKeys: PropTypes.array,  // 选中菜单keys
    };

    static defaultProps = {
        dataSource: [],
        theme: 'default',
        selectedKeys: [],
    };

    renderMenus() {
        const {dataSource} = this.props;
        if (dataSource && dataSource.length) {
            return renderNode(dataSource, (item, children) => {
                const {
                    key,
                    path,
                    text,
                    icon,
                    target,
                    url,
                } = item;
                let title = <span>{L(text)}</span>;
                if (icon) title = <span>
                    {
                        text === '流程中心' ? (
                            <IconFont type='icon-liuchengzhongxin-315' style={{fontSize:'16px'}}/>
                        ): null
                    }
                    {
                        text === '智能审核' ? (
                            <IconFont type='icon-zhinengshenheshenchashenhe' style={{fontSize:'16px'}}/>
                        ): null
                    }
                    {
                        text === '影像平台' ? (
                            <IconFont type='icon-yingxiangxitong' style={{fontSize:'16px'}}/>
                        ): null
                    }
                    {
                        text === '分类取数' ? (
                            <IconFont type='icon-zhengli' style={{fontSize:'16px'}}/>
                        ): null
                    }
                    {
                        text === '档案平台' ? (
                            <IconFont type='icon-danganguanli-dangantaizhang' style={{fontSize:'16px'}}/>
                        ): null
                    }
                    {
                        text === '报表管理' ? (
                            <IconFont type='icon-baobiao' style={{fontSize:'16px'}}/>
                        ): null
                    }
                    {
                        text === '测试' ? (
                            <IconFont type='icon-ceshi1' style={{fontSize:'16px'}}/>
                        ): null
                    }
                    <Icon type="home" style={{display: 'none'}}/><span style={{fontSize: '16px'}}>{L(text)}</span>
                    </span>;
                if (children) {
                    return (
                        <SubMenu key={key} title={L(title)}>
                            {children}
                        </SubMenu>
                    );
                }


                return (
                    <Menu.Item key={key}>
                        {target ? (
                            <a href={url} target={target}>
                                {L(title)}
                            </a>
                        ) : (
                            <Link to={{
                                pathname: path,
                                state: {from: 'menu'}
                            }}>
                                {L(title)}
                            </Link>
                        )}
                    </Menu.Item>
                );
            });
        }
        return null;
    }

    render() {
        const {
            theme,
            selectedKeys,
        } = this.props;
        return (
            <div styleName="header-menu">
                <Menu
                    selectedKeys={selectedKeys}
                    mode="horizontal"
                    theme={theme}
                >
                    {this.renderMenus()}
                </Menu>
            </div>
        );
    }
}
